export enum MimeType {
  PDF = 'application/pdf',
  CSV = 'text/csv',
  XML = 'application/xml',
  JPEG = 'image/jpeg'
}
